<template>
  <div class="px-0 pb-0 card-body">
    <div v-if="loading && filteredData.length === 0" class="text-center py-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="mt-2">Loading BDCOM GPON ONU data...</p>
    </div>
    <div class="table-responsive" v-else-if="filteredData.length > 0">
      <div class="card mb-4">
        <div class="card-body px-0 pt-0 pb-2 invoice">
          <div class="table-responsive p-0">
            <table class="table align-items-center mb-0">
              <thead>
                <tr>
                  <th
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Interface
                  </th>
                  <th
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    ONU Interface
                  </th>
                  <th
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    PPPOE ID
                  </th>
                  <th
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Serial Number
                  </th>
                  <th
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Loid
                  </th>
                  <th
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Deactive Time
                  </th>
                  <th
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Deactive Reason
                  </th>
                  <th
                    @click="$emit('sort', 'show')"
                    :class="{
                      asc: sortKey === 'show' && sortOrder === 'asc',
                      desc: sortKey === 'show' && sortOrder === 'desc',
                    }"
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Status
                    <span class="sort-icon"> </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(data, index) in filteredData" :key="index">
                  <td class="align-middle text-center text-sm">
                    {{ data.interface }}
                  </td>
                  <td class="align-middle text-center text-sm">
                    {{ data.onu_interface }}
                  </td>
                  <td class="align-middle text-center text-sm">
                    <span v-if="data.PPPOE_ID === 'Loading...'">
                      <span class="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
                    </span>
                    <span v-else>
                      {{ data.PPPOE_ID ?? 'N/A' }}
                    </span>
                  </td>
                  <td class="align-middle text-center text-sm">
                    {{ data.serial_number  }}
                  </td>
                  <td class="align-middle text-center text-sm">
                    {{ data.loid  }}
                  </td>
                  <td class="align-middle text-center text-sm">
                    {{ data.deactive_time  }}
                  </td>
                  <td class="align-middle text-center text-sm">
                    {{ data.deactive_reason == 'Losi' ? "Fiber Down / Optical Power Issue" : "Fiber Down" }}
                  </td>
                  <td class="text-center">
                    <soft-badge
                    class="p-1 rounded-1 cursor-pointer text-sm"
                    :class="{
                        'bg-warning bg-opacity-80 text-dark ': data.status.toLowerCase() === 'disabled',
                        'bg-danger bg-opacity-25 ': data.status.toLowerCase() === 'off-line'
                    }"
                    variant="gradient"
                    size="sm"
                    >
                    {{ data.status == "off-line" ? "Offline" : "Disabled" }}
                    </soft-badge>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <Skalaton />
    </div>
  </div>
</template>

<script>
import Skalaton from "@/components/Skalaton.vue";

export default {
  name: "OnuTable",
  components: {
    Skalaton
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    filteredData: {
      type: Array,
      default: () => []
    },
    sortKey: {
      type: String,
      default: ""
    },
    sortOrder: {
      type: String,
      default: "asc"
    }
  }
};
</script>

<style scoped>
td {
  padding: 12px 24px !important;
}

.sort-icon {
  margin-left: 5px;
}

.asc::after {
  content: "▲";
}

.desc::after {
  content: "▼";
}
</style>